// extracted by mini-css-extract-plugin
module.exports = {"styledDropdownMenu":"ig_gm7nO","optionWrapper":"bndNZOft","label":"OsQnZOUU","styledInput":"gCBwyhKw","styledButton":"WJX4XNII"};